import React, { FC } from 'react';
import { CustomModal } from '../../molecules';
import { SaveToProfileModalProps } from './index.types';

export const SaveToProfileModal: FC<SaveToProfileModalProps> = ({
  heading,
  children,
  primaryButtonLabel,
  handleButtonClick,
}) => {
  return (
    <CustomModal
      openModal={true}
      heading={heading}
      optionsModal={false}
      handleClose={handleButtonClick ?? (() => undefined)}
      primaryButtonLabel={primaryButtonLabel}
      handleButtonClick={handleButtonClick ?? (() => undefined)}
    >
      {children}
    </CustomModal>
  );
};

export default React.memo(SaveToProfileModal);
